import script from "./CallToAction7525Layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallToAction7525Layout.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__